import { APIPATHENV } from "./env"

const APIPATH = APIPATHENV
const getHeader = (token) => {
  const auth = `Bearer ${token}`
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json;charset=UTF-8',
  }
  if (token != undefined)
    headers.Authorization = auth
  return headers
}

const ACTION = {
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
}

const commorReducer = (state, action) => {
  switch (action.type) {
    case ACTION.LOADING: {
      return {
        ...state,
        loading: true,
        error: false
      }
    }
    case ACTION.ERROR: {
      return {
        ...state,
        data: action.payload,
        loading: false,
        statusCode: action.statusCode,
        error: true
      }
    }
    case ACTION.SUCCESS: {
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: false,
        totalRecords: action.total,
        statusCode: action.statusCode
      }
    }
    default: {
      return {
        ...state,
        error: true,
      }
    }
  }
}

const businessCheck = (_history) => {
  const usertype = localStorage.getItem('usertype')
  if (usertype === 'Owner') {
    const isBusinessAvailable = JSON.parse(localStorage.getItem('isBusinessAvailable'))
    if (isBusinessAvailable === false) {
      _history('/business/create')
    }
  }
}

const isEmpty = (val) => {
  return (val === undefined || val == null || val === '') ? true : false;
}

export { APIPATH, ACTION, getHeader, commorReducer, businessCheck, isEmpty }
